export enum ProgressRootDataAttributes {
  /**
   * Present when the progress has completed.
   */
  complete = 'data-complete',
  /**
   * Present when the progress is in indeterminate state.
   */
  indeterminate = 'data-indeterminate',
  /**
   * Present while the progress is progressing.
   */
  progressing = 'data-progressing',
}
